<template class="container">
  <div class="page landscape">
    <div class="background"></div>
    <Logo />
    <h1>Pricing</h1>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'

export default {
  name: 'Pricing',
  components: {
    Logo,
  },
}
</script>

<style scoped>
.page {
  background: url('/trader.jpg');
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  /* z-index: 0; */
  /* text-transform: uppercase; */
}

h1 {
  transform: rotate(30deg);
  margin-top: -40px;
  margin-left: -40px;
}
</style>
